import moment from 'moment';
import React from 'react';
import { Table } from 'react-bootstrap';

const ActiveClockinsTable = ({ data }) => {
    return (
        <div className="card-body px-0 py-0">
            <div className="table-responsive overflow-x-scroll">
                <Table responsive striped bordered hover className="exchange-history table shadow-hover tickettable display mb-4 dataTablesCard dataTable no-footer">
                    <thead>
                        <tr>
                            <th className="fs-14 font-w600 border-0">Team Member</th>
                            <th className="fs-14 font-w600 border-0">Property</th>
                            <th className="fs-14 font-w600 border-0">Role</th>
                            <th className="fs-14 font-w600 border-0">Status</th>
                            <th className="fs-14 font-w600 border-0">Login Time</th>
                        </tr>
                    </thead>
                    <tbody className=''>
                        {data?.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <h5 className="mb-0">{item.resource}</h5>
                                </td>
                                <td className="fs-14 font-w400 text-capitalize">{item.property_name}</td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <span className="font-w600 fs-14 text-capitalize">{item.role_name}</span>
                                    </div>
                                </td>
                                <td className='text-capitalize text-danger'>{item.status_val}</td>
                                <td>
                                    <span className="font-w600 fs-14 text-capitalize text-secondary">{item.login_time ?
                                        moment(item?.login_time).format('MMMM Do, YYYY hh:mm a') : '-'}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ActiveClockinsTable;
